// src/utils/toDateSafe.js
// يحوّل أي شكل تاريخ ممكن نستلمه (Firestore Timestamp مباشر بـ.toDate(),
// أو {seconds}/{_seconds} القادم من رد API خلفي، أو Date، أو نص/رقم) إلى
// كائن Date عادي - أو null إذا ما نقدر. نفس المنطق المستخدم مسبقاً بعدة
// أماكن بالمشروع (AdminDashboard.js, SmartAccountingSystem.js, ...).

export const toDateSafe = (ts) => {
  try {
    if (!ts) return null;

    if (typeof ts.toDate === "function") return ts.toDate();

    if (typeof ts.seconds === "number") {
      return new Date(ts.seconds * 1000);
    }

    if (typeof ts._seconds === "number") {
      return new Date(ts._seconds * 1000);
    }

    if (ts instanceof Date) {
      return ts;
    }

    if (typeof ts === "string" || typeof ts === "number") {
      const d = new Date(ts);
      return Number.isNaN(d.getTime()) ? null : d;
    }

    return null;
  } catch {
    return null;
  }
};
